import "./styles.scss";

import { useCallback, useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import ModalMobile from "components/ModalMobile";
import TextEditor, {
  convertToHTML,
  htmlToDraftBlocks,
} from "components/TextEditor";

const mainClass = "task-view-main-modal-description";

const ModalDescription = ({
  id,
  text,
  isUploading,
  isCompletelyDisabled,
  isOpen,
  editMessage,
  onClose,
}) => {
  const { t } = useTranslation();
  const [content, setContent] = useState(null);
  const init = useRef(false);

  useLayoutEffect(() => {
    if (text && !init.current) {
      setContent(htmlToDraftBlocks(text));
      init.current = true;
    }
  }, [text]);

  const handleSubmit = useCallback(() => {
    if (id && typeof editMessage === "function") {
      editMessage(id, convertToHTML(content), [], [], true);
      onClose();
    }
  }, [id, content, editMessage, onClose]);

  return (
    <ModalMobile
      title={t("Edit description")}
      hasMobileScrollTop={false}
      isOpen={isOpen}
      isFlexColumn
      onClose={onClose}
    >
      <div className={mainClass}>
        <TextEditor
          id="description-modal"
          content={content}
          setContent={setContent}
          isDisabled={isUploading}
          isCompletelyDisabled={isCompletelyDisabled}
          onSubmit={handleSubmit}
        />
      </div>
    </ModalMobile>
  );
};

export default ModalDescription;
